











































import Vue from 'vue';

export default Vue.extend({
  name: 'AppNavigation',
  // data() {
  //   return {
  //     drawer: null as null | boolean, // null so that vuetify can detect screen size and set appropriately
  //     items: [
  //       {
  //         title: 'Home',
  //         icon: 'home',
  //         to: '/',
  //       },
  //       {
  //         title: 'About',
  //         icon: 'people_alt',
  //         to: '/about',
  //       },
  //     ],
  //   };
  // },
  computed: {
    logo(): string {
      return require('@/assets/sh-logo.png');
    },
    // showMenuBtn(): boolean {
    //   return this.$route.meta.showMenuBtn;
    // },
  },
  methods: {
    // toggleDrawer(e: Event) {
    //   this.drawer = !this.drawer;
    // },
  },
});
